import type { Breadcrumb } from "@sentry/react";

/** Parametry podpisu presigned URL S3 (`X-Amz-Signature`, `X-Amz-Credential`, token sesji…). */
const SIGNED_URL_PARAM = /([?&])(X-Amz-[A-Za-z-]+)=[^&#]*/g;
const HAS_SIGNED_URL_PARAM = /[?&]X-Amz-/;

/** Maskuje wartości wszystkich parametrów `X-Amz-*`; adres bez nich wraca bez zmian. */
export const scrubPresignedUrl = (url: string): string =>
  url.replace(SIGNED_URL_PARAM, "$1$2=[Filtered]");

/**
 * `beforeBreadcrumb` Sentry (ASMMNT-83, etap 2): okruszki fetch/xhr niosą pełny adres presigned
 * PUT/GET do skanów i PDF-ów umów. Podpis jest ważny najwyżej 300 s, ale nie ma po co trafiać
 * do zewnętrznego narzędzia. Okruszek bez podpisanego adresu wraca tą samą referencją.
 */
export const scrubBreadcrumb = (breadcrumb: Breadcrumb): Breadcrumb => {
  const url = breadcrumb.data?.url;
  if (typeof url !== "string" || !HAS_SIGNED_URL_PARAM.test(url)) {
    return breadcrumb;
  }
  return {
    ...breadcrumb,
    data: { ...breadcrumb.data, url: scrubPresignedUrl(url) },
  };
};
